import { type ReactNode, useState, useEffect } from 'react';
import {
  DropdownOverlayWrapper,
  DropdownWrapper,
  IconWrapper,
  OverlayWrapper,
} from './DropdownOverlay.styles';
import DropdownIcon from '../DropdownIcon/DropdownIcon';
import useResizeResponsive from '@/hooks/useResizeResponsive';
import { isDesktop } from '@/modules/utils/breakpoints';

interface DropdownOverlayProps {
  dropdown: ReactNode;
  children: ReactNode;
}

function DropdownOverlay(props: DropdownOverlayProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktopWidth = useResizeResponsive(isDesktop);

  useEffect(() => {
    const closeOverlay = () => setIsOpen(false);
    if (isOpen)
      isDesktopWidth
        ? document.addEventListener('scroll', closeOverlay)
        : (document.body.style.overflow = 'hidden');

    return () => {
      isDesktopWidth
        ? document.removeEventListener('scroll', closeOverlay)
        : (document.body.style.overflow = 'auto');
    };
  }, [isOpen]);

  return (
    <DropdownOverlayWrapper isOpen={isOpen}>
      <DropdownWrapper onClick={() => setIsOpen(!isOpen)}>
        {props.dropdown}
        <IconWrapper>
          <DropdownIcon isOpen={isOpen} />
        </IconWrapper>
      </DropdownWrapper>

      <OverlayWrapper isOpen={isOpen}>{props.children}</OverlayWrapper>
    </DropdownOverlayWrapper>
  );
}

export default DropdownOverlay;
